import { render, staticRenderFns } from "./TabsDashboardAlerts.vue?vue&type=template&id=a3203eb0&"
import script from "./TabsDashboardAlerts.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports